var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { getAuth, signInWithCredential, GoogleAuthProvider, } from 'firebase/auth';
import { ref, remove, onValue } from 'firebase/database';
import { useNavigate } from 'react-router';
import { database } from '../../../config/firebaseConfig';
import generatePushID from '../../../../../shared/utils/generate-pushid';
import Button from '../../../components/Button';
import googleLogo from './google-logo.svg';
import getBrowserVersion from '../../../scripts/getBrowserVersion';
import { _signInWithPopup } from '../../../redux/actions';
var auth = getAuth();
var GoogleAuth = function (props) {
    var navigate = useNavigate();
    var signInWithGoogle = function () {
        var _a;
        // if user is on Electron app
        if (window.electron) {
            var authCode_1 = generatePushID();
            var oneTimeCodeRef = ref(database, "auth-codes/auth".concat(authCode_1, "/idToken"));
            var unsubscribe_1 = onValue(oneTimeCodeRef, function (snapshot) { return __awaiter(void 0, void 0, void 0, function () {
                var authToken, credential;
                return __generator(this, function (_a) {
                    authToken = snapshot.val();
                    if (authToken) {
                        unsubscribe_1();
                        credential = GoogleAuthProvider.credential(authToken);
                        signInWithCredential(auth, credential)
                            .then(function (userCredential) {
                            var _a;
                            // user is signed in
                            var user = userCredential.user;
                            console.log('signed in!', { user: user });
                            (_a = window.electron) === null || _a === void 0 ? void 0 : _a.send('app/focus');
                            // not needed to dispatch anything since
                            // checkIfUserIsLoggedIn() action automatically
                            // detects changes in state and calls signIn()
                            remove(ref(database, "auth-codes/auth".concat(authCode_1)));
                        })
                            .catch(function (error) {
                            console.log({ error: error });
                        });
                    }
                    return [2 /*return*/];
                });
            }); }, function (error) {
                console.log(error);
            });
            (_a = window.electron) === null || _a === void 0 ? void 0 : _a.send('browser/authenticate', { authCode: authCode_1 });
        }
        // if user is instead in the browser
        else {
            var browser = getBrowserVersion();
            if (browser.name === 'Safari' && browser.version == '16') {
                // continue with POPUP
                _signInWithPopup();
            }
            else {
                // continue with REDIRECT
                navigate('google');
            }
        }
    };
    return (React.createElement(Button, { label: props.label, onClick: signInWithGoogle, icon: googleLogo, id: 'continue-with-google' }));
};
export default GoogleAuth;
